

import Default from '../components/dashboard/default'
import DetailedDashboard from '../components/dashboard/detailedDashboard'
import Reports from '../pages/visites/Reports'
import DetailedReport from '../pages/visites/DetailedReport'
import FocusReports from '../pages/visites/Focus'
import FocusDetailedReport from '../pages/visites/FocusDetailedReport'
import AddDuoVisit from '../pages/visites/AddVisitDuo'
import DuoVisitsList from '../pages/visites/DuoList'
import DuoVisitDetail from '../pages/visites/DuoVisitDetailedReport'
import SynthesesList from '../pages/syntheses/SynthesesList'
import AddSynthese from '../pages/syntheses/AddSyntheses'
// import SyntheseDetails from '../pages/syntheses/SynthesesDetails'
import EnAttente from '../pages/tournée/attente'
import Valides from '../pages/tournée/valides'
import Contacts from '../pages/contacts/contacts'
import Addcontact from '../pages/contacts/Addcontact'
import DetailedContact from '../pages/contacts/detailedContact'
import ModifyContact from '../pages/contacts/modifyContact'
import Users from '../pages/users/Users'
import UserDetails from '../pages/users/UserDetails'
import AddUser from '../pages/users/AddUser'
import modifyUser from '../pages/users/modifyUser'
import Products from '../pages/products/Products'
import ValidesDetailed from '../pages/tournée/validesDetailed'
import PendingDetailed from '../pages/tournée/pendingDetailed'
import AgentStats from '../pages/stats/agentStats'
import ProductStats from '../pages/stats/ProductStats'
import ProductFilteredReports from '../pages/stats/ProductFilteredReports'
import AgentDetailedProgress from '../pages/stats/AgentDetailedProgress'
import Parameters from '../pages/paramaeters/Parameters'
import ParametersRatio from '../pages/paramaeters/ParametersRatio'
import AddProducts from '../pages/products/addProducts'
import EditProduct from '../pages/products/editProduct'
import Bdc from '../pages/bdc/bdcList'
import BdcDetailed from '../pages/bdc/bdcDetailed'
import GrossisteList from '../pages/grossiste/grossisteList'
import GrossisteDetailed from '../pages/grossiste/grossisteDetailed'
import SynthesesDetails from '../pages/syntheses/SynthesesDetails'


export const routes = [
  { path: "/dashboard/default", Component: Default },
  { path: "/dashboard/default/detailed", Component: DetailedDashboard },
  { path: "/grossiste/list", Component: GrossisteList },
  { path: "/grossiste/detailed", Component: GrossisteDetailed },

  { path: "/visites/rapports", Component: Reports },
  { path: "/visites/rapports/detailed", Component: DetailedReport },
  { path: "/focus/rapports", Component: FocusReports },
  { path: "/focus/rapports/detailed", Component: FocusDetailedReport },

  { path: "/tournee/valides", Component: Valides },
  { path: "/tournee/valides/detailed/:slug", Component: ValidesDetailed },
  { path: "/tournee/enattente", Component: EnAttente },
  { path: "/tournee/enattente/detailed/:slug", Component: PendingDetailed },

  { path: "/bdc", Component: Bdc },
  { path: "/bdc/detailed", Component: BdcDetailed },

  { path: "/contacts", Component: Contacts },
  { path: "/contacts/add", Component: Addcontact },
  { path: "/contacts/modify/:slug", Component: ModifyContact },
  { path: "/contacts/contact/:slug", Component: DetailedContact },

  { path: "/users", Component: Users },
  { path: "/users/add", Component: AddUser },
  { path: "/users/user/:slug", Component: UserDetails },
  { path: "/visitesDuo/add", Component: AddDuoVisit },
  { path: "/visitesDuo/rapports", Component: DuoVisitsList },
  { path: "/visiteDuo/rapportDetails", Component: DuoVisitDetail },
  { path: "/syntheses/liste", Component: SynthesesList },
  { path: "/syntheses/detailed", Component: SynthesesDetails },
  { path: "/syntheses/add", Component: AddSynthese },
  { path: "/users/modify", Component: modifyUser },

  { path: "/products", Component: Products },
  { path: "/products/add", Component: AddProducts },
  { path: "/product/edit/:slug", Component: EditProduct },

  { path: "/stats/agents", Component: AgentStats },
  { path: "/stats/agents/detailed", Component: AgentDetailedProgress },
  { path: "/stats/products", Component: ProductStats },
  { path: "/stats/products/reports", Component: ProductFilteredReports },
  
  { path: "/settings", Component: Parameters },
  { path: "/settings/ratio", Component: ParametersRatio },
]